import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { BellIcon, Cog8ToothIcon, MagnifyingGlassIcon, Bars3Icon, XMarkIcon, Bars3BottomLeftIcon } from "@heroicons/react/24/outline";
import "./Header.css";
import baseUrl from "../../config";
import axios from "axios";
import cat from '../../Assets/avatar/cat.png'; // Example static image, replace with your own
import woman from '../../Assets/avatar/woman.png'; // Example static image, replace with your own
import man from '../../Assets/avatar/man.png'; // Example static image, replace with your own
const AVATAR_PATHS = [
  cat,  
  woman,
  man,  ];
const Header = ({ onMobileSidebarToggle, toggleSidebar, isSidebarCollapsed, isMobileSidebarOpen }) => {
  const navigate = useNavigate();
  const [isNotificationsOpen, setIsNotificationsOpen] = useState(false);
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
  const [userName, setUserName] = useState("Leo");
    const [userAvatar, setUserAvatar] = useState("Leo");
 const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [isDarkMode, setIsDarkMode] = useState(false);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          setError('Authentication token not found. Please log in.');
          setLoading(false);
          return;
        }

        const response = await axios.get(`${baseUrl}api/students/v2/profile`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
   
        setUserAvatar(AVATAR_PATHS[0]);


        setLoading(false);
      } catch (err) {
        console.error('Error fetching profile:', err);
        setError(err.response?.data?.message || 'Failed to load profile data. Please try again.');
        setLoading(false);
      }
    };

    fetchProfile();
  }, []);
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user && user.name) {
      setUserName(user.name);

    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    navigate("/login");
    setIsSettingsOpen(false);
  };

  const handleToggle = () => {
    if (window.innerWidth < 1024) {
      onMobileSidebarToggle();
    } else {
      toggleSidebar();
    }
  };


  const notifications = [
    // { id: 1, text: "New assignment in Creative Writing!", time: "10 min ago" },
    // { id: 2, text: "You earned a 'Math Whiz' badge! 🎉", time: "1 hr ago" },
    // { id: 3, text: "Reminder: Science Fair project due tomorrow.", time: "2 hrs ago" },
  ];

  return (
    <header className="main-header flex items-center justify-between p-4 sticky top-0 z-30">
      <div className="flex items-center space-x-1 md:space-x-2">
    <button onClick={() => window.innerWidth < 1024 ? onMobileSidebarToggle() : toggleSidebar()} className="menu-btn">
          <Bars3Icon className="icon" />
        </button>

        <div className="user-avatar-circle flex-shrink-0 animate-bounce-subtle">
   <img
  src={userAvatar} // NO BASE_URL HERE!
                alt={`${userAvatar} Profile`}
                onError={(e) => { e.target.onerror = null; e.target.src = "https://placehold.co/128x128/a2d2ff/000000?text=Default"; }} // Fallback image
              />        </div>

        <h1 className="welcome-text text-xl md:text-1xl font-bold hidden sm:block truncate">
          Welcome <span className="highlight-name">{userName}!</span>
        </h1>
        <h1 className="welcome-text text-lg font-bold block sm:hidden">Welcome!</h1>
      </div>

      <div className="flex items-center space-x-3 md:space-x-4">
        <div className="relative">
          <input
            type="text"
            placeholder="Search assignments, courses..."
            className="search-input"
            onFocus={(e) => e.target.classList.add("search-input-focused")}
            onBlur={(e) => e.target.classList.remove("search-input-focused")}
          />
          <MagnifyingGlassIcon className="w-5 h-5 text-gray-500 absolute left-3 top-1/2 transform -translate-y-1/2" />
        </div>

        <div className="relative">
          <button
            className="p-2 rounded-full hover:bg-gray-100 transition-colors duration-200 relative focus:outline-none focus:ring-2 focus:ring-blue-300"
            onClick={() => {
              setIsNotificationsOpen(!isNotificationsOpen);
              setIsSettingsOpen(false); // Close settings if open
            }}
            aria-label="Notifications"
          >
            <BellIcon className="w-6 h-6 md:w-7 md:h-7 text-gray-700" />
            {notifications.length > 0 && (
              <span className="absolute -top-1 -right-1 w-3 h-3 bg-red-500 rounded-full border-2 border-white" />
            )}
          </button>
          {isNotificationsOpen && (
            <div className="absolute right-0 mt-2 w-64 bg-white rounded-lg shadow-xl py-2 z-40 transform origin-top-right animate-fade-in-scale">
              <div className="px-4 py-2 text-sm font-semibold text-gray-600 border-b border-gray-200">
                Notifications
              </div>
              {notifications.length > 0 ? (
                notifications.map((notification) => (
                  <div key={notification.id} className="px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 cursor-pointer transition-colors duration-150">
                    <p className="font-medium">{notification.text}</p>
                    <p className="text-xs text-gray-500 mt-1">{notification.time}</p>
                  </div>
                ))
              ) : (
                <p className="px-4 py-2 text-sm text-gray-500 italic">No new notifications.</p>
              )}
              <div className="border-t border-gray-200 mt-2 pt-2">
                <button
                  onClick={() => setIsNotificationsOpen(false)}
                  className="w-full text-center px-4 py-2 text-sm text-blue-600 hover:bg-blue-50 transition-colors duration-150 rounded-b-lg focus:outline-none focus:ring-2 focus:ring-blue-300"
                >
                  Close
                </button>
              </div>
            </div>
          )}
        </div>

        {/* Settings Dropdown */}
        <div className="relative">
          <button
            className="p-2 rounded-full hover:bg-gray-100 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-300"
            onClick={() => {
              setIsSettingsOpen(!isSettingsOpen);
              setIsNotificationsOpen(false); // Close notifications if open
            }}
            aria-label="Settings"
          >
            <Cog8ToothIcon className="w-6 h-6 md:w-7 md:h-7 text-gray-700" />
          </button>
          {isSettingsOpen && (
            <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-xl py-2 z-40 transform origin-top-right animate-fade-in-scale">
              <div className="px-4 py-2 text-sm font-semibold text-gray-600 border-b border-gray-200">
                Settings
              </div>
              <button
                className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 cursor-pointer transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-blue-300"
                onClick={() => {
                  navigate("/profile");
                  setIsSettingsOpen(false); // Close settings after navigation
                }}
              >
                Profile
              </button>
              <div className="border-t border-gray-200 mt-2 pt-2">
                <button
                  onClick={handleLogout}
                  className="w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition-colors duration-150 rounded-b-lg focus:outline-none focus:ring-2 focus:ring-red-300"
                >
                  Log Out
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;